export default __webpack_public_path__ + "static/media/LuanaLelis_page.d989bdfc.png";